module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    class: (_vm.top) ? 'top' : ''
  }, [(_vm.closeBtnPos == 'full') ? _c('span', {
    staticClass: "fullCloseBtn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/btn_close.svg"),
      "width": "30"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: (_vm.styleObject)
  }, [(_vm.closeBtnPos == 'window') ? _c('span', {
    staticClass: "windowCloseBtn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/btn_close.svg"),
      "width": "30"
    }
  })]) : _vm._e(), _vm._v(" "), (this.$slots['header']) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), (this.$slots['body']) ? _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2) : _vm._e(), _vm._v(" "), (this.$slots['footer']) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "modal-default-button btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("\n              OK\n            ")])]
  })], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91ab1618!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 802
// module chunks = 3